// Secure URL fragments carry credentials, not page anchor names.
export function pageAnchor(document, {pathname='',hash=''}={}) {
 if(pathname.replace(/\/+$/,'')==='/bill-share'||!hash||hash==='#')return null;
 try{return document.getElementById(decodeURIComponent(hash.slice(1)));}
 catch{return null;}
}
